/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_001: Question = {
  id: 'pres-001-milieux-connectivite',
  oldId: '15',
  title: 'Identification des milieux naturels d’intérêt pour la connectivité',
  number: '2.1',
  description: [''],
  idEM: 2,
  type: QuestionType.ACTIVITY,
  frequency: 5,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_001__v3: Question = {
  ...question_pres_001,
  frequency: 4,
};

export const question_pres_001_v2: Question = question_pres_001;
export const question_pres_001_v3: Question = question_pres_001__v3;
